var _defs, _rect, _path, _path2, _path3, _polygon, _rect2, _path4, _path5, _circle, _rect3, _circle2, _path6, _path7, _circle3, _path8, _circle4, _path9, _path10, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _polygon2, _path11, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172.33 157.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2b6eae;}.b,.j{fill:#5badff;}.c,.l,.m{fill:#114374;}.c,.h,.i{opacity:0.2;}.d,.e{fill:#1df3ce;}.d{opacity:0.3;}.f,.i{fill:#0083e8;}.g,.h{fill:#fff;}.g,.j{opacity:0.5;}.k{fill:#dcedfc;}.m{opacity:0.1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "consult") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 76.32,
    y: 45.95,
    width: 2.01,
    height: 10.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M898.85,4121h0a0.9,0.9,0,0,1-.9.9h-11.4a0.9,0.9,0,0,1-.9-0.9v-1.24h13.21V4121Z",
    transform: "translate(-814.92 -4062.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M885.64,4119.78h0a2.72,2.72,0,0,1,2.72-2.72h7.77a2.72,2.72,0,0,1,2.72,2.72",
    transform: "translate(-814.92 -4062.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M898.85,4121h0a0.9,0.9,0,0,1-.9.9h-11.4a0.9,0.9,0,0,1-.9-0.9v-1.24h13.21V4121Z",
    transform: "translate(-814.92 -4062.6)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "135.53 157.4 68.19 157.4 98.19 54.46 105.53 54.46 135.53 157.4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 123.6,
    y: 45.95,
    width: 2.01,
    height: 10.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M946.12,4121h0a0.9,0.9,0,0,1-.9.9h-11.4a0.9,0.9,0,0,1-.9-0.9v-1.24h13.21V4121Z",
    transform: "translate(-814.92 -4062.6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M932.91,4119.78h0a2.72,2.72,0,0,1,2.72-2.72h7.77a2.72,2.72,0,0,1,2.72,2.72",
    transform: "translate(-814.92 -4062.6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 101.98,
    cy: 44.4,
    r: 14.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 101.36,
    y: 3.4,
    width: 1,
    height: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 101.98,
    cy: 44.4,
    r: 9.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M916.78,4087.75A37.45,37.45,0,0,0,883.51,4108h66.55A37.45,37.45,0,0,0,916.78,4087.75Z",
    transform: "translate(-814.92 -4062.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M949.87,4108h0.19a37.46,37.46,0,0,0-66.55,0h0.19A48.37,48.37,0,0,1,949.87,4108Z",
    transform: "translate(-814.92 -4062.6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 101.86,
    cy: 25.15,
    r: 9.19
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M916.78,4091.42A9.2,9.2,0,0,1,908,4085a9.19,9.19,0,1,0,17.54,0A9.2,9.2,0,0,1,916.78,4091.42Z",
    transform: "translate(-814.92 -4062.6)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 101.86,
    cy: 3.15,
    r: 3.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M916.78,4067.12a3.14,3.14,0,0,1-3-2.26,3.11,3.11,0,0,0-.14.89,3.15,3.15,0,1,0,6.29,0,3.11,3.11,0,0,0-.14-0.89A3.14,3.14,0,0,1,916.78,4067.12Z",
    transform: "translate(-814.92 -4062.6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M950.05,4108a2.71,2.71,0,0,1-2.71,2.71H886.22a2.71,2.71,0,0,1-2.71-2.71",
    transform: "translate(-814.92 -4062.6)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    y: 109.4,
    width: 29.33,
    height: 48
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74,
    y: 127.4,
    width: 33,
    height: 30
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 29.33,
    y: 86.07,
    width: 44.67,
    height: 71.33
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 141.67,
    y: 109.4,
    width: 30.67,
    height: 48
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 107,
    y: 96.74,
    width: 34.67,
    height: 60.67
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 5.99,
    y: 118.39,
    width: 17.88,
    height: 5.18
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 37.93,
    y: 94.14,
    width: 10.37,
    height: 10.25
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 55.03,
    y: 94.14,
    width: 10.37,
    height: 10.25
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 112.99,
    y: 106.06,
    width: 8.56,
    height: 21.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 127.11,
    y: 106.06,
    width: 8.56,
    height: 21.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 37.93,
    y: 109.4,
    width: 10.37,
    height: 10.25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 55.03,
    y: 109.4,
    width: 10.37,
    height: 10.25
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 37.93,
    y: 124.4,
    width: 10.37,
    height: 10.25
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 55.03,
    y: 124.4,
    width: 10.37,
    height: 10.25
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 5.99,
    y: 129.53,
    width: 17.88,
    height: 5.18
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 148.06,
    y: 118.39,
    width: 17.88,
    height: 5.18
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 148.06,
    y: 129.53,
    width: 17.88,
    height: 5.18
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 79.4,
    y: 133.48,
    width: 22.2,
    height: 7.64
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 112.99,
    y: 133.48,
    width: 22.2,
    height: 7.64
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 37.93,
    y: 82.35,
    width: 10.37,
    height: 3.72
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 82.81,
    y: 123.57,
    width: 15.38,
    height: 3.72
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 112.99,
    y: 89.8,
    width: 8.56,
    height: 6.93
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "135.53 157.4 68.19 157.4 77.05 127.4 106.97 127.38 107 96.73 117.85 96.73 135.53 157.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M946.12,4121h0a0.9,0.9,0,0,1-.9.9h-11.4a0.9,0.9,0,0,1-.9-0.9v-1.24h13.21V4121Z",
    transform: "translate(-814.92 -4062.6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M902.93,4110.71a14.37,14.37,0,0,0,1.08,2.85h25.78a14.37,14.37,0,0,0,1.08-2.85H902.93Z",
    transform: "translate(-814.92 -4062.6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsult);
export default __webpack_public_path__ + "static/media/consult.7c15f217586736ada68352a4ecff027c.svg";
export { ForwardRef as ReactComponent };